export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8435.599a9926.jpg";